import React, { Component, Fragment } from 'react'
import LanguageLinks from '../Components/LanguageLinks'

class LanguageLinksContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showLanguageLinks: false,
            showCountries: false,
        }
    }

    toggleShowLanguageLinks() {
        this.setState(() => ({
            showLanguageLinks: !this.state.showLanguageLinks,
            showCountries: false,
        }))
    }

    toggleShowCountries() {
        this.setState(() => ({
            showLanguageLinks: false,
            showCountries: !this.state.showCountries,
        }))
    }

    render() {
        return (
            <Fragment>
                {this.props && this.props.values && this.props.values.links && (
                    <div className="language-link">
                        <LanguageLinks
                            {...{
                                ...this.props.values,
                                showLanguageLinks: this.state.showLanguageLinks,
                                toggleShowLanguageLinks: () =>
                                    this.toggleShowLanguageLinks(),
                                showCountries: this.state.showCountries,
                                toggleShowCountries: () =>
                                    this.toggleShowCountries(),
                            }}
                        />
                    </div>
                )}
            </Fragment>
        )
    }
}

export default LanguageLinksContainer
